import styled from "styled-components";

interface IBackgroundProps {
    position?: string
    text: string
}

export default styled.div<IBackgroundProps>`
    position: absolute;

    &::before {
        color: #fff;
        content: "${ ({ text }) => text }";
        font-family: Inter, sans-serif;
        font-size: 24vmin;
        font-weight: bold;
        letter-spacing: -2vmin;
        line-height: 18vmin;
        opacity: .1;
        position: fixed;
        text-transform: uppercase;
        z-index: -1;
        word-spacing: 100vw;

        ${ ({ position = "" }) => position.includes("right") ? "text-align: right;" : "" }
        ${ ({ position = "" }) => position.includes("right") ? "right: 0;" : "left: -3vmin;" }
        ${ ({ position = "" }) => position.includes("bottom") ? "bottom: 32px;" : "top: 4vmin;" }
    }
`;

export const BackgroundLarge = styled.div`
    position: absolute;

    &::before {
        color: #fff;
        content: "${ ({ text }) => text }";
        font-family: Inter, sans-serif;
        font-size: 140vmin;
        font-weight: bold;
        left: 0vmin;
        letter-spacing: -8vmin;
        opacity: .04;
        position: fixed;
        text-transform: uppercase;
        top: -20vmin;
        z-index: -1;
    }
`;
